// Export the tour steps for PaymentInfo component
export const paymentGuideSteps = [
  {
    element: "#SAFI-payment-info",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Payment Information</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Set up your payment methods to receive commissions from your affiliate activities. You need at least 2 payment methods configured.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">This information is used to process your earnings and commission payouts.</p>
          </div>
        </div>`,
      side: "top" as const,
      align: "start" as const,
    },
  },
];